/**
 * Insert letterQrBlock as a direct child of doc, adjacent to the top-level
 * block under the current selection.
 *
 * @param {{ $from: { depth: number, after: (depth: number) => number }, to?: number }} selection
 * @returns {number | null} document position, or null when unresolved
 */
export function resolveLetterQrDocInsertPos(selection) {
  if (!selection || typeof selection !== 'object') return null;
  const $from = selection.$from;
  if (!$from || typeof $from.depth !== 'number') return null;

  if ($from.depth >= 1) {
    if (typeof $from.after !== 'function') return null;
    try {
      const pos = $from.after(1);
      return typeof pos === 'number' && pos >= 0 ? pos : null;
    } catch {
      return null;
    }
  }

  // Top-level NodeSelection / depth 0: insert after the selected node.
  if (typeof selection.to === 'number' && selection.to >= 0) {
    return selection.to;
  }
  return null;
}

/**
 * Pure JSON helper for tests: insert QR after a top-level doc child index.
 * @param {object} document
 * @param {number} afterTopLevelIndex
 */
export function insertLetterQrBlockAfterTopLevelIndex(document, afterTopLevelIndex) {
  const content = Array.isArray(document?.content) ? [...document.content] : [];
  const qr = { type: 'letterQrBlock', attrs: { align: 'center' } };
  const index = Math.max(-1, Math.min(afterTopLevelIndex, content.length - 1));
  content.splice(index + 1, 0, qr);
  return { type: 'doc', content };
}

/**
 * @param {object} document
 */
export function countLetterQrBlocksInDocument(document) {
  if (!document || document.type !== 'doc' || !Array.isArray(document.content)) return 0;
  return document.content.filter((node) => node?.type === 'letterQrBlock').length;
}
